import React from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import HomePage from './pages/HomePage';
import TeamPage from './pages/TeamPage';
import TeamMemberPage from './pages/TeamMemberPage';
import TestimonialsPage from './pages/TestimonialsPage';
import ComprehensiveMentalHealthPage from './pages/ComprehensiveMentalHealthPage';
import OutpatientMentalHealthPage from './pages/services/OutpatientMentalHealthPage';
import MedicationManagementPage from './pages/services/MedicationManagementPage';
import TreatmentPlansPage from './pages/services/TreatmentPlansPage';
import PRPPage from './pages/services/PRPPage';
import CommunityResourcesPage from './pages/services/CommunityResourcesPage';
import ComprehensiveAssessmentPage from './pages/services/ComprehensiveAssessmentPage';
import StudentCounselingPage from './pages/services/StudentCounselingPage';
import AngerManagementPage from './pages/services/AngerManagementPage';
import ParentingCounselingPage from './pages/services/ParentingCounselingPage';
import SocialEngagementPage from './pages/services/SocialEngagementPage';
import JuvenileJusticePage from './pages/services/JuvenileJusticePage';
import ReferralsPage from './pages/services/ReferralsPage';
import CaseManagementPage from './pages/services/CaseManagementPage';
import VeteranServicesPage from './pages/services/VeteranServicesPage';
import TelehealthPage from './pages/services/TelehealthPage';
import InsurancePage from './pages/InsurancePage';
import FAQPage from './pages/FAQPage';
import MentalHealthResourcesPage from './pages/MentalHealthResourcesPage';
import CareersPage from './pages/CareersPage';
import EmergencyBanner from './components/EmergencyBanner';
import SocialFloatingBar from './components/SocialFloatingBar';
import MentalHealthAssessmentPage from './pages/MentalHealthAssessmentPage';
import AdminLoginPage from './pages/AdminLoginPage';
import AdminDashboard from './pages/AdminDashboard';
import ReferralDetailPage from './pages/ReferralDetailPage';
import GetStartedPage from './pages/GetStartedPage';
import ResourcesPage from './pages/ResourcesPage';
import IntakePage from './pages/IntakePage';
import IntakeDetailPage from './pages/IntakeDetailPage';
import DepressionTreatmentPage from './pages/resources/DepressionTreatmentPage';
import AnxietyTreatmentPage from './pages/resources/AnxietyTreatmentPage';
import PTSDSupportPage from './pages/resources/PTSDSupportPage';
import BaltimoreCityPage from './pages/areas/BaltimoreCityPage';
import BaltimoreCountyPage from './pages/areas/BaltimoreCountyPage';
import AboutSdoraPage from './pages/AboutSdoraPage';
import ReferralRequirementsPage from './pages/providers/ReferralRequirementsPage';
import PartnerWithSdoraPage from './pages/providers/PartnerWithSdoraPage';
import ProviderResourcesPage from './pages/providers/ProviderResourcesPage';
import NotFoundPage from './pages/NotFoundPage';
import usePageView from './hooks/usePageView';
import './App.css';

function AppContent() {
  const location = useLocation();
  const isAdminRoute = location.pathname.startsWith('/admin');
  usePageView();

  return (
    <>
      {!isAdminRoute && <EmergencyBanner />}
      {!isAdminRoute && <SocialFloatingBar />}
      <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/team" element={<TeamPage />} />
          <Route path="/team/:staffId" element={<TeamMemberPage />} />
          <Route path="/testimonials" element={<TestimonialsPage />} />
          <Route path="/services/comprehensive-mental-health" element={<ComprehensiveMentalHealthPage />} />
          <Route path="/services/outpatient-mental-health" element={<OutpatientMentalHealthPage />} />
          <Route path="/services/medication-management" element={<MedicationManagementPage />} />
          <Route path="/services/treatment-plans" element={<TreatmentPlansPage />} />
          <Route path="/services/psychiatric-rehabilitation" element={<PRPPage />} />
          <Route path="/services/community-resources" element={<CommunityResourcesPage />} />
          <Route path="/services/comprehensive-assessment" element={<ComprehensiveAssessmentPage />} />
          <Route path="/services/student-counseling" element={<StudentCounselingPage />} />
          <Route path="/services/anger-management" element={<AngerManagementPage />} />
          <Route path="/services/parenting-counseling" element={<ParentingCounselingPage />} />
          <Route path="/services/social-engagement" element={<SocialEngagementPage />} />
          <Route path="/services/juvenile-justice" element={<JuvenileJusticePage />} />
          <Route path="/services/referrals" element={<ReferralsPage />} />
          <Route path="/services/case-management" element={<CaseManagementPage />} />
          <Route path="/services/veteran-services" element={<VeteranServicesPage />} />
          <Route path="/services/telehealth" element={<TelehealthPage />} />
          <Route path="/insurance" element={<InsurancePage />} />
          <Route path="/faq" element={<FAQPage />} />
          <Route path="/resources" element={<ResourcesPage />} />
          <Route path="/resources/mental-health" element={<MentalHealthResourcesPage />} />
          <Route path="/resources/depression-treatment" element={<DepressionTreatmentPage />} />
          <Route path="/resources/anxiety-treatment" element={<AnxietyTreatmentPage />} />
          <Route path="/resources/ptsd-support" element={<PTSDSupportPage />} />
          <Route path="/areas/baltimore-city" element={<BaltimoreCityPage />} />
          <Route path="/areas/baltimore-county" element={<BaltimoreCountyPage />} />
          <Route path="/careers" element={<CareersPage />} />
          <Route path="/about" element={<AboutSdoraPage />} />
          <Route path="/providers/referral-requirements" element={<ReferralRequirementsPage />} />
          <Route path="/providers/partner" element={<PartnerWithSdoraPage />} />
          <Route path="/providers/resources" element={<ProviderResourcesPage />} />
          <Route path="/self-assessment" element={<MentalHealthAssessmentPage />} />
          <Route path="/get-started" element={<GetStartedPage />} />
          <Route path="/intake" element={<IntakePage />} />
          <Route path="/admin" element={<AdminLoginPage />} />
          <Route path="/admin/dashboard" element={<AdminDashboard />} />
          <Route path="/admin/referral/:id" element={<ReferralDetailPage />} />
          <Route path="/admin/intake/:id" element={<IntakeDetailPage />} />
          <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </>
  );
}

function App() {
  return (
    <HelmetProvider>
      <BrowserRouter>
        <AppContent />
      </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;
